module.exports = __webpack_public_path__ + "static/media/HCMM301.cfd19092.jpg";